module.exports = __webpack_public_path__ + "img/lang.bd3d550b.png";